import React from 'react';

import { LazyNBMPerformanceReportPage } from '@confluence/nbm-performance-report/entry-points/LazyNBMPerformanceReportPage';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminNBMPerformanceReportRoute = () => <LazyNBMPerformanceReportPage />;

AdminNBMPerformanceReportRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'adminNBMPerformanceReport' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
